import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import API from "./apiCalls/accountAPI";
import jobTransitionAPI from "./apiCalls/jobTransitionCalls";
import { getCookie, logout } from "./util/index";
import asyncComponent from "./HOC/AsyncComponent";
import { get } from "lodash";
import store from './store';
import { setCurrentBrokerJob } from './actions/searchContextActions';
import './i18n';
import { XmlRendererWithRouter } from './xmlRenderer';
import { XmlReviewerWithRouter } from "./xmlReviewer";
import { XmlSentWithRouter } from "./xmlSent";
import { XmlRequestWithRouter } from "./xmlRequest";
import JobQueueHeader from "./components/JobQueue/JobQueueHeader";
import ReconApp from "./Recon_App/index";
import { AppContext, AppProvider } from "./appProvider";
//import { LogLevel } from '@grafana/faro-web-sdk';
import { getBrokerUiEnvironment } from './util/index';
import { getQueryVariable } from "./apiCalls/jobInfo";
import { Dimmer, Segment } from "semantic-ui-react";
import { SquareLoader } from "kx-common-components";
import _ from "lodash";
import PreDailyPage from "./components/AccountMenu/components/payment/cbp-service/PreDailyPage";
import ManageProductHistory from "./components/AccountMenu/components/productLineHistory/History";
import Parts from "./components/AccountMenu/components/productLineHistory/Parts";
const AsyncLogin = asyncComponent(() => {
  return import("./components/Login/Login.js");
});
const AsyncJobQueue = asyncComponent(() => {
  return import("./containers/JobQueueContainer");
});
const AsyncForgot = asyncComponent(() => {
  return import("./components/Login/Forgot.js");
});
const AsyncReset = asyncComponent(() => {
  return import("./components/Login/Reset.js");
});



const optionsState = {
  AL: "AL", AK: "AK", AZ: "AZ", AR: "AR", CA: "CA", CO: "CO", CT: "CT", DE: "DE", FL: "FL", GA: "GA",
  HI: "HI", ID: "ID", IL: "IL", IN: "IN", IA: "IA", KS: "KS", KY: "KY", LA: "LA", ME: "ME", MD: "MD",
  MA: "MA", MI: "MI", MN: "MN", MS: "MS", MO: "MO", MT: "MT", NE: "NE", NV: "NV", NH: "NH", NJ: "NJ",
  NM: "NM", NY: "NY", NC: "NC", ND: "ND", OH: "OH", OK: "OK", OR: "OR", PA: "PA", RI: "RI", SC: "SC",
  SD: "SD", TN: "TN", TX: "TX", UT: "UT", VT: "VT", VA: "VA", WA: "WA", WV: "WV", WI: "WI", WY: "WY",
}

const optionsCountry = {
  USA: "United States",
  KH: "Canada"
}
const euCountries = ['ES', 'NL'];
export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kxUser: "",
      low: 0,
      high: 0,
      direction: "DESC",
      count: 0,
      shipId: "NoJobsAvailable",
      bolNumber: "",
      bolDocNumber: "",
      clickedShipId: "",
      kxToken: getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN),
      toggleInProcess: false,
      toggleCompleted: false,
      filterContainerOpen: true,
      formValidatedForSV: false,
      aceOpen: false,
      selectedOpsForm: "",
      redirect: "/",
      selectedForm: "DOC_ISF",
      clickedShipIdHasBeenChanged: false,
      myAccountOpen: false,
      modalOpen: "",
      sessionData: {
        email: "",
        fullName: "",
        phone: ""
      },
      filterModalOpen: false,
      newerDisabled: true,
      olderDisabled: false,
      loadingJobs: true,
      shipmentCountry: ""
    };
    App.routeUser = App.routeUser.bind(this);
    this.setCurrentJobData = this.setCurrentJobData.bind(this)
  }

  setShipmentCountry = (countryCode, countryOfBusiness) => {
    this.setState({
      shipmentCountry: countryCode,
      countryOfBusiness: countryOfBusiness
    })
  }

  validateUserInformation = (userData, paymentInfo) => {

    let validInfo = [true, true];
    try {
      if (userData.userInfo.bondInfo.bondNumber.length <= 0) validInfo[0] = false;
      if (userData.userInfo.bondInfo.bondAmount.length <= 0) validInfo[0] = false;
      if (userData.userInfo.bondInfo.bondType.length <= 0) validInfo[0] = false;
      if (userData.userInfo.bondInfo.bondOwner.length <= 0) validInfo[0] = false;
    } catch {
      validInfo[0] = false;
    }
    try {
      if (paymentInfo[0].paymentMethod.length <= 0) validInfo[1] = false;
      if (paymentInfo[0].fullName.length <= 0) validInfo[1] = false;
      if (paymentInfo[0].paymentInstrumentGuid.length <= 0) validInfo[1] = false;
      if (paymentInfo[0].lastFourDigit.length <= 0) validInfo[1] = false;
      if (paymentInfo[0].expiryDate.length <= 0) validInfo[1] = false;
      if (paymentInfo[0].type.length <= 0) validInfo[1] = false;
    } catch {
      validInfo[1] = false;
    }
    return validInfo;
  };

  getImporterList = (filerCode, kxUserData) => {
    API.getImporterList(filerCode).then((res) => {
      let importerList = res.data.eventMessage.userGuidFilerCodeMap;
      importerList.forEach((item) => {
        item.value = (item.value).toUpperCase()
        item.text = item.value;
      })
      setTimeout(() => {
        kxUserData.importerList = importerList;
        this.setState({
          kxUser: kxUserData
        });
        sessionStorage.setItem("kxUser", JSON.stringify(kxUserData))
      }, 0)
    }).catch(() => {
      this.setState({
        kxUser: kxUserData
      });
    })
  }
  setUserData = () => {
    API.getUserInfo(getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN))
      .then((responses) => {
        return Promise.all(responses.map(function (res) {
          return res.json();
        }));
      })
      .then((responseData) => {
        if(responseData.find(xdata=>xdata.eventType=="GET_KXUSER")?.eventMessage?.code >= 400){
          alert("KX User is missing! Some UI elements may not work properly!")
        }
        if (responseData[0].msg == "Failed") {
          if (window.confirm("It looks like you were logged out. Redirecting to login page...")) {
            logout();
          }
        }

        let kxUserData = responseData[0].eventMessage;
        kxUserData.teamMembers = responseData[1].eventMessage.teamMembers;
        kxUserData.channelConnections = responseData[2].eventMessage.channelConnections;
        window.typeOfUser = kxUserData.userBasicInfo.typeOfUser;
        let filerCode = get(kxUserData, "userInfo.brokerAdditionalInfo.accountSecurityNumber") || get(kxUserData, "userInfo.brokerAdditionalInfo.filerCode");
        this.getImporterList(filerCode, kxUserData);
        let countryCode = get(kxUserData, "userInfo.brokerAdditionalInfo.countryCode", "");
        if (euCountries.includes(countryCode) && !localStorage.getItem("expandIsfFormWidthb")) {
          localStorage.setItem("expandIsfFormWidthb", "true")
        }
      })
  };

  getPaymentData = async () => {
    try {
      const response = await API.getPaymentData(getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN));
      let userPaymentData = response.eventMessage.paymentInstruments;
      this.setState({ paymentData: userPaymentData });
    } catch (err) {
      console.error("ERROR getting payment data:", err);
    }
  };

  getCompanyInfo = () => {
    let info = this.convertArrayToMap(get(this.state, "kxUser.userInfo.companyInformation.businessAddress", ""));
    let businessName = get(this.state, "kxUser.userInfo.companyInformation.businessName", "");
    let address = info["STREET_NUMBER"];
    let address2 = info["STREET_NAME"];
    let city = info["CITY"];
    let state = info["COUNTRY_SUB_ENTITY"] !== "" ? info["COUNTRY_SUB_ENTITY"] : optionsState["AL"];
    let zip = info["POSTAL_CODE"];
    let country = info["COUNTRY"] !== "" ? info["COUNTRY"] : optionsCountry["USA"];
    let entryMin = get(this.state, "kxUser.entryNumberDetails.startRange", null);
    let entryMax = get(this.state, "kxUser.entryNumberDetails.endRange", null);

    API.companyInfo(getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN), "", businessName, address, address2, city, state, zip, country, entryMin, entryMax)
      .then((res) => {
        return res.json();
      })
      .then((response) => {
        if (response.msg === "Event not allowed without valid token" || response.msg === "Expired Token" || response.code === 401) {
          console.log('"Event not allowed without valid token": ', "Event not allowed without valid token");
          logout();
        }
      })
      .catch((err) => console.error("companyInfo", err));
  };

  // Converts shipping destinations array into a map
  convertArrayToMap = (arr) => {
    let temp = [];
    for (let i = 0; i < arr.length; i++) temp[arr[i].type] = arr[i].information ? arr[i].information : "";
    return temp;
  };

  componentWillMount() {
    if (window.location.pathname === "/broker-panel") {
      let kxToken = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
      if (kxToken.length > 0) {
        let kxUserData = "";
        let userPaymentData = "";
        this.setUserData()

        API.getPaymentData(getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN))
          .then((response) => {
            return response;
          })
          .then((responseData) => {
            if (responseData.data) {
              let userPaymentData = responseData.data.eventMessage.paymentInstruments;
              this.setState({ paymentData: userPaymentData });
            }
          })
          .catch((err) => console.error(err));

        this.setState({
          infoFilled: this.validateUserInformation(kxUserData, userPaymentData)
        });
      }
    }
  }

  toggleModal = (name) => {
    this.setState({ modalOpen: name });
  };

  setCurrentJobData = (shipmentId) => {
    if (!(shipmentId || window.shipmentId)) {
      return;
    }
    jobTransitionAPI.searchCurrentJob(shipmentId).then((res) => {
      for(let onejob of res?.data?.eventMessage?.brokerJobs?.currentBrokerJobs ||[]){
        onejob.countryCode = onejob.countryCode || getQueryVariable("countryHttpParameter");
      }
      let currentJobState = get(res.data.eventMessage, "brokerJobs.currentBrokerJobs");
      if(currentJobState && currentJobState.length){
        currentJobState[0].timeRemaining = null;
      }
      if(_.isEqual(window[`GLOBAL_LastJobData${shipmentId}`],currentJobState)){
        return;
      }
      window[`GLOBAL_LastJobData${shipmentId}`] = currentJobState;
      store.dispatch(setCurrentBrokerJob(shipmentId, currentJobState))
    })
  }

  beforeUnloadListener = () => {
    sessionStorage.removeItem("DROPDOWN_VAL")
  }

  currentShipmentInterval = (myInterval) => {
    this.setState({
      currentJobInterval: setInterval(() => {
        let isEngineView = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN ==  'kxEngineBrokerToken';
        let nonActiveCard = document.getElementsByClassName("broker-card broker-card-wrapper").length;
        let hasActiveCard = document.getElementsByClassName(" broker-card broker-card-wrapper active selected").length;
        if (nonActiveCard && !hasActiveCard && window.shipmentMode !== "LVS_SHIPMENTS" && !(this.state.clickedShipIdHasBeenChanged && isEngineView)) {
          document.getElementsByClassName("broker-card broker-card-wrapper")[0].click();
        }
        this.setCurrentJobData(this.state.clickedShipId)
      }, myInterval)
    })

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.clickedShipId !== this.state.clickedShipId) {
      //alert("componentDidUpdate");
      clearInterval(this.state.currentJobInterval)
      this.currentShipmentInterval(6000);

    }
  }

  async componentDidMount() {
    if(!getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN) && window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN ==  'kxEngineBrokerToken'){
      return;
    }

    
    const env = getBrokerUiEnvironment();
    if (window.location.pathname === "/broker-panel") {
      await this.props.setDocumentTypes();
      if (this.state.loadingJobs) {
        this.getMyBrokerJobs();
      }
      if (this.state.shipId === "NoJobsAvailable") {
        this.getMyBrokerJobs(250);
        // this.setState({
        //   jobInterval: setInterval(() => {
        //     this.getMyBrokerJobs();
        //   }, 30000)
        // })

        this.currentShipmentInterval(6000);
      }
      window.addEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
      // if ((env === "prod" || env === "dev") && window.faro) {
      //   console.log('faro', 'faro find logging app.js component did mount');
      //   window.faro.api.pushLog(['faro find logging app.js component did mount'], { level: LogLevel.Debug });
      // }
    }
    if (getQueryVariable("onlyOneShipment")) {
      sessionStorage.setItem("onlyOneShipment", "true");
    }
  }

  componentWillUnmount() {
    //clearInterval(this.state.jobInterval)
    clearInterval(this.state.currentJobInterval)
    window.removeEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
  }

  getMyBrokerJobs = async () => {
    this.props.getBrokerShipmentList(()=>{},(resAgain)=>{
        let newShipmentId = _.get(resAgain,"data.eventMessage.brokerJobs.currentBrokerJobs[0].shipmentId");
        if(!this.state.autosetClcikedShipmentId && newShipmentId){
          this.setState({autosetClcikedShipmentId:true});
          this.getClickedShipId(newShipmentId);
          try {
            document.getElementsByClassName("broker-card broker-card-wrapper")[0].click();
          } catch(eeee){}
        }
      })
      .then((res) => {
        this.setState({
          loadingJobs: false,
          newerDisabled: false
        });
      });
  };

  static routeUser() {
    document.location = "/broker-panel"+window.location.search;
  }

  toggleState = (target = "") => {
    target !== "" && this.setState({ [target]: !this.state[target] });
  };

  getClickedShipId = (id) => {
    this.setState({ clickedShipId: id, clickedShipIdHasBeenChanged:true },
      ()=>{this.setCurrentJobData(id)}
      );
  };

  toggle = (name, value) => this.setState({ [name]: value });

  // setShipmentMode= (mode) => {
  //   this.setState({"shipmentMode":mode})
  // }
  render() {
    // const {contextState , toggleModalfromContext ,toggleAccountMenu,myAccountOpen} = useAppContext()
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      kxToken: getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN)
    };
    let kxUser = sessionStorage.getItem("kxUser");
    let filerCode = get(kxUser, "userInfo.brokerAdditionalInfo.accountSecurityNumber") || get(kxUser, "userInfo.brokerAdditionalInfo.filerCode")
    return (
      <div className={(getQueryVariable("onlyOneShipment") ||sessionStorage.getItem("onlyOneShipment")?'onlyShowOneShipment':'')+
          (getQueryVariable('docOnlyBroker')=='true'?' docOnlyBroker ':' ')}>
      <AppProvider>
        <AppContext.Consumer>
          {(context) => (
            <Router>
              <React.Fragment>
                <Switch>
                  <Route exact path="/" render={(props) => <AsyncLogin {...props} mainState={this.state} shipId={this.state.shipId} routeUser={App.routeUser} />} />
                  <Route exact path="/forgot" render={(props) => <AsyncForgot {...props} mainState={this.state} routeUser={App.routeUser} />} />
                  <Route exact path="/reset-password/:tmp" render={(props) => <AsyncReset {...props} mainState={this.state} routeUser={App.routeUser} />} />
                  <Route exact path="/custom-statement"
                    render={() => (
                      <PreDailyPage
                        infoFilled={this.state.infoFilled}
                        kxUser={this.state.kxUser || JSON.parse(sessionStorage.getItem("kxUser"))}
                        getPaymentData={this.getPaymentData}
                        setUserData={this.setUserData}
                      />
                    )}
                  />
                  <Route exact path="/parts-library"
                    render={() => (
                      <ManageProductHistory
                        filerCode={filerCode}
                      />
                    )}
                  />
                  <Route exact path="/parts"
                    render={() => (
                      <Parts
                        filerCode={filerCode}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/broker-panel"
                    render={() => (
                      <>
                        <JobQueueHeader
                          toggle={context.toggleAccountMenu}
                          toggleModal={context.toggleModalfromContext}
                          myAccountOpen={context.contextState.myAccountOpen}
                          profile={this.state.kxUser}
                        />
                          <AsyncJobQueue
                          currentJobState={this.props.currentJobState}
                          docTypes={this.props.docTypes}
                          currentBrokerJobs={this.props.brokerJobs}
                          getMyBrokerJobs={this.getMyBrokerJobs}
                          infoFilled={this.state.infoFilled}
                          toggleModal={context.toggleModalfromContext}
                          toggle={context.toggleAccountMenu}
                          filteredJobs={this.state.filteredJobs}
                          toggleState={this.toggleState}
                          headers={headers}
                          getClickedShipId={this.getClickedShipId}
                          mainState={this.state}
                          customModalOpen={context.contextState.modalOpen}
                          customAccountMenuOpen={context.contextState.myAccountOpen}
                          shipId={this.state.shipId}
                          getCustomerShipments={this.getCustomerShipments}
                          kxUser={this.state.kxUser}
                          paymentData={this.state.paymentData}
                          setUserData={this.setUserData}
                          getPaymentData={this.getPaymentData}
                          shipmentCountry={this.state.shipmentCountry}
                          setShipmentCountry={this.setShipmentCountry}
                        />
                       
                      </>
                    )}
                  />
                  <Route
                    exact
                    path="/broker-panel/xml-preview/:countryCode/:shipId/:status/:responseId"
                    render={() => (
                      <XmlRendererWithRouter />
                    )}
                  />
                  <Route
                    exact
                    path="/broker-panel/xml-review/:shipId/:formType"
                    render={() => (
                      <XmlReviewerWithRouter />
                    )}
                  />
                  <Route
                    exact
                    path="/broker-panel/xml-sent/:countryCode/:shipId"
                    render={() => (
                      <XmlSentWithRouter />
                    )}
                  />
                  <Route
                    exact
                    path="/broker-panel/xml-request/:countryCode/:shipId/:requestId"
                    render={() => (
                      <XmlRequestWithRouter />
                    )}
                  />
                  <Route
                    exact
                    path="/broker-panel/recon"
                    render={() => (
                      <ReconApp kxUser={this.state.kxUser} />
                    )}
                  />

                </Switch>
              </React.Fragment>
            </Router>
          )}
        </AppContext.Consumer>
      </AppProvider>
      </div>
    );
  }
}
